export const keyboardKeys = {
  ENTER: 'Enter',
}
